import { EncounterSumary, EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useEncounterUpdate = () =>
  useMutationWithLoading(
    async (params: { encounterSumary: EncounterSumary; xTENANTID?: string }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).updateEncounterSummary(params.encounterSumary, params.xTENANTID)
  );
